import React, { useState, useRef, useEffect } from "react";
import Layout from "containers/Layout";
import "react-dropdown/style.css";
import { getListTicket, updateDataSearch } from "../../../actions/Ticket";
import { Headersubfull } from "../../GenericComponent/HeaderSubFull/headersubfull";
import { SearchBarDesktop } from "./SearchBarDesktop";
import { SearchBarMobile } from "./SearchBarMobile";
import { useSelector, useDispatch } from "react-redux";
import { TableDanhSach } from "./TableDanhSach";
import { AddTaiKhoanBtn } from "./AddTaiKhoanBtn";
import StoreApi from "service/phanQuyenApi";
import DsCapPheDuyetApi from "../../../service/QuyTrinhPheDuyet/CapPheDuyet/dsCapPheDuyetApi";
import LayoutV2 from "containers/LayoutV2";

export const DanhSachCapPheDuyet = () => {
  const dispatch = useDispatch();
  const [dataBank, setDataBank] = useState({});
  const dataSearch = useSelector((state) => state.dataSearchTaiKhoanBank);
  const initPhanQuyen = {
    quytrinhpheduyet_danhsach: false,
    quytrinhpheduyet_cappheduyet: false,
    quytrinhpheduyet_cauhinhchoduyet: false,
    quytrinhpheduyet_quanlygoivay: false,
  };
  const [phanQuyen, setPhanQuyen] = useState(initPhanQuyen);
  useEffect(() => {
    document.title = "Danh sách cấp phê duyệt | Phần mềm quản lý cầm đồ Morman";
    LoadPhanQuyen();
    onSearch();
  }, []);
  const LoadPhanQuyen = () => {
    StoreApi.phanQuyenQuyTrinhPheDuyet().then((response) => {
      setPhanQuyen({
        ...phanQuyen,
        quytrinhpheduyet_danhsach: response.data.quytrinhpheduyet_danhsach,
        quytrinhpheduyet_cappheduyet:
          response.data.quytrinhpheduyet_cappheduyet,
        quytrinhpheduyet_cauhinhchoduyet:
          response.data.quytrinhpheduyet_cauhinhchoduyet,
        quytrinhpheduyet_quanlygoivay:
          response.data.quytrinhpheduyet_quanlygoivay,
      });
    });
  };
  const onSearch = () => {
    DsCapPheDuyetApi.list({
      sSearch: dataSearch.sSearch,
      iPageSize: dataSearch.iPageSize,
      iPageIndex: dataSearch.iPageIndex,
    }).then((response) => {
      if (response.status == "200") {
        setDataBank(response.data);
      }
    });
  };
  return (
    <LayoutV2>
      {phanQuyen.quytrinhpheduyet_cappheduyet && (
        <div id="form-repeater">
          <div className="sticky-moman-bh">
            <div className="col-12">
              <div className="camdo-home">
                <div className="breadcrumb-new mb-1">
                  <div className="row">
                    <div className="col-sm-12 col-md-12 title-cd">
                      <div className="media-home align-center-home">
                        <div class="row header">
                          {/* <div className="col-sm-6"> */}
                          <img
                            className="icon-bred-home"
                            src="/app-assets/images/logo-cam-do-v2.png"
                            alt=""
                          />
                          <h1 className="text-info-home">Cấp phê duyệt</h1>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card border-light mb-1 hidden-mobile-main show-table-main card-v2">
                  <div className="card-body card-body-v2">
                    <SearchBarDesktop onSearch={onSearch} />
                  </div>
                </div>
              </div>
              <SearchBarMobile onSearch={onSearch} />
              <AddTaiKhoanBtn data={""} onSearch={onSearch} />
            </div>
          </div>
          <TableDanhSach dataDanhSach={dataBank} onSearch={onSearch} />
        </div>
      )}
      {!phanQuyen.quytrinhpheduyet_cappheduyet && (
        <div id="form-repeater">
          <div className="sticky-moman-bh">
            <div className="col-12">
              <div className="camdo-home">
                <div className="breadcrumb-new mb-1">
                  <div className="row">
                    <div className="col-sm-12 col-md-12 title-cd">
                      <div className="media-home align-center-home">
                        <div class="row header">
                          {/* <div className="col-sm-6"> */}
                          <img
                            className="icon-bred-home"
                            src="/app-assets/images/logo-cam-do-v2.png"
                            alt=""
                          />
                          <h1 className="text-info-home">Cấp phê duyệt</h1>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <span
            style={{
              textAlign: "center",
              color: "red",
              display: "flex",
              justifyContent: "center",
            }}
          >
            Bạn không có quyền truy cập chức năng này.
          </span>
        </div>
      )}
    </LayoutV2>
  );
};
